import apiClient from './base/apiClient'

/**
 * 푸시를 눌러서 들어왔다고 서버에 알린다.
 *
 * 앱은 알림을 누르면 목적지로 이동만 하고 서버에 알리지 않는다. 그래서
 * 푸시 주소에 from=<캠페인> 표식을 달아두고, 그 주소로 들어왔을 때 웹이
 * 대신 알려준다. 앱을 고칠 필요가 없다.
 *
 * 실패해도 조용히 넘어간다 — 통계를 남기려다 화면이 멈추면 안 된다.
 */
export async function reportPushOpened(campaign: string): Promise<void> {
  try {
    await apiClient.post('/push/opened', { campaign })
  } catch {
    /* 통계는 실패해도 사용자에게 영향이 없어야 한다 */
  }
}
